import { Base, Collection } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { AccountEmailPreferenceResource } from './AccountEmailPreference';
import { EmployerProfileResource } from './EmployerProfile';
import { UserProfileResource } from './UserProfile';

/**
 * Relationship classes
 */
export class AccountAttributes {
  createdAt: string = null;
  email: string = null;
  emailNotifications: boolean = null;
  id: string = null;
  onboardComplete: boolean = null;
  password: string = null;
  smsNotifications: boolean = null;
  updatedAt: string = null;
}

export class AccountHasOne {
  userProfile: () => UserProfileResource = () => new UserProfileResource();
}

export class AccountHasMany {
  employerProfiles: () => Collection<EmployerProfileResource> = () =>
    new Collection<EmployerProfileResource>();
  accountEmailPreferences: () => Collection<AccountEmailPreferenceResource> = () =>
    new Collection<AccountEmailPreferenceResource>();
}

/**
 * Utility interfaces
 */
export interface AccountMethods {}

export interface AccountInterface
  extends AccountAttributes,
    AccountHasOne,
    AccountHasMany,
    AccountType {}

type AccountType = GConstructor<AccountInterface>;

export interface AccountResource
  extends Base<AccountAttributes>,
    AccountInterface,
    AccountMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<AccountAttributes>({
    queryName: 'account',
    className: 'Account',
    AttributesClass: AccountAttributes,
    HasOneClasses: [
      {
        Klass: AccountHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: AccountHasMany,
      },
    ],
  });

export const AccountResourceClass = <TBase extends AccountType>(BaseConstructor: TBase): TBase =>
  class extends BaseConstructor implements AccountMethods {};

export class AccountResource extends ClassExtender<AccountInterface>(
  BaseClass,
  AccountResourceClass,
) {}

/**
 * Resource instance
 */
export const Account = APILibrary.createResource<AccountResource>(AccountResource);
